import { render, staticRenderFns } from "./Challenges.vue?vue&type=template&id=3dfbc860&scoped=true"
import script from "./Challenges.vue?vue&type=script&lang=js"
export * from "./Challenges.vue?vue&type=script&lang=js"
import style0 from "./Challenges.vue?vue&type=style&index=0&id=3dfbc860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfbc860",
  null
  
)

export default component.exports